import '../utilities/stringUtils.js';
import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useState, createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import '../TextInput/TextInput.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import 'date-fns';
import { HOURS_REGEXP_12, HOURS_REGEXP_24, MIN_MINUTES, MAX_MINUTES, MINUTES_REGEXP } from './constants.js';
import { j as getRelativeModeOptions, R as RELATIVE_FIELD_POSITION, k as getHoursLimitValues, l as getMeridiemOptions } from '../utils-1a2b02cb.js';
import './Field.js';
import TimeField from './TimeField.js';
import TimePeriodFormatField from './TimePeriodFormatField.js';

const PanelContent = styled(Div)`
  display: flex;
  align-items: center;
  padding: ${({
  theme
}) => `${theme.spacing.sm}px 0`};
`;

const PanelControls = styled(Div)`
  display: flex;
  justify-content: end;
  margin-top: ${({
  theme
}) => theme.spacing.xs}px;
`;

const PanelRoot = styled(Div)`
  padding: ${({
  theme
}) => `${theme.spacing.md}px`};
  width: 100%;
`;

const TimeDivider = styled(Span)`
  margin: ${({
  theme
}) => `0 ${theme.spacing.md}px`};
`;

const TimePickerPanel = ({
  initialHours,
  initialMinutes,
  initialMeridiem,
  initialRelativeMode,
  onApply,
  onCancel,
  useMeridiem,
  mode,
  labels,
  relativeFieldPosition,
  onBeforeCancel
}) => {
  const theme = useTheme();
  const isRelativeMode = mode === 'relative';
  const {
    minHoursValue,
    maxHoursValue
  } = getHoursLimitValues(useMeridiem);
  const meridiemOptions = getMeridiemOptions();
  const relativeModeOptions = getRelativeModeOptions(labels);
  const [meridiem, setMeridiem] = useState(meridiemOptions.find(option => option.value === initialMeridiem));
  const [relativeMode, setRelativeMode] = useState(relativeModeOptions.find(option => option.value === initialRelativeMode) || relativeModeOptions[0]);
  const [hours, setHours] = useState(useMeridiem && initialHours === 0 ? 12 : initialHours);
  const [minutes, setMinutes] = useState(initialMinutes);
  const isLeftRelativeFieldPosition = relativeFieldPosition === RELATIVE_FIELD_POSITION.LEFT;
  const handleApply = () => {
    onApply({
      hours: hours || 0,
      minutes: minutes || 0,
      meridiem: meridiem.value,
      relativeMode: relativeMode.value
    });
  };
  const handleCancel = () => {
    onBeforeCancel === null || onBeforeCancel === void 0 ? void 0 : onBeforeCancel();
    onCancel();
  };
  const renderRelativeField = () => {
    if (!isRelativeMode) return null;
    return /*#__PURE__*/createElement(Fragment, null, !isLeftRelativeFieldPosition && /*#__PURE__*/createElement(TimeDivider, null, ":"), /*#__PURE__*/createElement(TimePeriodFormatField, {
      value: relativeMode,
      onChange: setRelativeMode,
      name: "relativeMode",
      options: relativeModeOptions,
      onEnterPress: handleApply,
      styles: {
        input: {
          textTransform: 'capitalize'
        }
      }
    }), isLeftRelativeFieldPosition && /*#__PURE__*/createElement(TimeDivider, null, ":"));
  };
  return /*#__PURE__*/createElement(PanelRoot, {
    testId: "timePickerContent"
  }, /*#__PURE__*/createElement(PanelContent, null, isLeftRelativeFieldPosition && renderRelativeField(), /*#__PURE__*/createElement(TimeField, {
    value: hours,
    onChange: setHours,
    name: "hours",
    label: labels.hours,
    minValue: minHoursValue,
    maxValue: maxHoursValue,
    onEnterPress: handleApply,
    regexp: useMeridiem ? HOURS_REGEXP_12 : HOURS_REGEXP_24
  }), /*#__PURE__*/createElement(TimeDivider, null, ":"), /*#__PURE__*/createElement(TimeField, {
    value: minutes,
    onChange: setMinutes,
    name: "minutes",
    label: labels.minutes,
    minValue: MIN_MINUTES,
    maxValue: MAX_MINUTES,
    onEnterPress: handleApply,
    regexp: MINUTES_REGEXP
  }), useMeridiem && !isRelativeMode && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(TimeDivider, null), /*#__PURE__*/createElement(TimePeriodFormatField, {
    value: meridiem,
    onChange: setMeridiem,
    name: "timePeriodFormat",
    options: meridiemOptions,
    onEnterPress: handleApply,
    styles: {
      input: {
        textTransform: 'uppercase'
      }
    }
  })), !isLeftRelativeFieldPosition && renderRelativeField()), /*#__PURE__*/createElement(PanelControls, null, /*#__PURE__*/createElement(Button, {
    variant: "tertiary",
    small: true,
    styles: {
      root: {
        border: `2px solid ${theme.palette.primary.main}`,
        p: `${theme.spacing.xxs}px ${theme.spacing.lg}px`,
        lineHeight: 1
      }
    },
    onClick: handleCancel
  }, labels.cancel), /*#__PURE__*/createElement(Button, {
    variant: "primary",
    small: true,
    styles: {
      root: {
        ml: `${theme.spacing.sm}px`,
        p: `${theme.spacing.xxs}px ${theme.spacing.lg}px`,
        lineHeight: 1
      }
    },
    onClick: handleApply
  }, labels.apply)));
};

export default TimePickerPanel;
